import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit'
import { API_CONFIG, API_LIST } from '../../Constants/ApiDefinations'
import { AffiliatePartnersListResponse, CreateMastersData } from '../../Models'
import mainApiService from '../../Services'
import { setLoader } from './loader.slice'

interface AffiliatePartnersState {
  affiliatePartnerData: AffiliatePartnersListResponse | null
}

const initialState: AffiliatePartnersState = {
  affiliatePartnerData: null,
}

const affiliatePartnersSlice = createSlice({
  name: 'affiliatePartners',
  initialState,
  reducers: {
    setAffiliatePartnersData: (state, action) => {
      state.affiliatePartnerData = action?.payload ? action.payload : null
    },
  },
})

export const { setAffiliatePartnersData } = affiliatePartnersSlice.actions

const affiliatePartnersSelector = (state: any) => state.affiliatePartners

export const selectAffiliatePartnerData = createSelector(
  affiliatePartnersSelector,
  (state) => state.affiliatePartnerData,
)

export const createAffiliatePartnerService = createAsyncThunk(
  'affiliatePartners/create',
  async (payload: CreateMastersData, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = API_CONFIG(
      API_LIST.MASTER_APIS.ADD_SYSTEM_CONFIG,
      {
        value: { key: payload.key, status: payload.status, value: payload.value },
        master: 'AFFILIATEPARTNERS',
      },
      {
        type: 'AFFILIATEPARTNERS',
      },
    )
    const data = await mainApiService(requestedData)
    dispatch(setLoader(false))
    return data
  },
)

export const editAffiliatePartnerService = createAsyncThunk(
  'affiliatePartners/editAffiliatePartner',
  async (payload: CreateMastersData, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = API_CONFIG(
      API_LIST.MASTER_APIS.ADD_SYSTEM_CONFIG,
      {
        value: { key: payload.key, status: payload.status, value: payload.value },
        master: 'AFFILIATEPARTNERS',
        systemConfigId: payload?.id,
      },
      {
        type: 'AFFILIATEPARTNERS',
      },
    )
    const data = await mainApiService(requestedData)
    dispatch(setLoader(false))
    return data
  },
)

export default affiliatePartnersSlice
